import {Button, Card, CardBody, CardHeader, Input} from "reactstrap";
import React, {Component, Fragment} from "react";
import {getData, patchData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {getTaxYear, TaxIntakeStatusList} from "../../constants/TaxIntakeConstants";
import TaxIntakeEditor from "./modals/TaxIntakeEditor";
import {getFormFieldValue} from "../Applications/shared/shared";
import {addHours} from "../../util/datehelpers";
import {getGlobalState} from "../../constants/GlobalStore";
import {DropSelection} from "./components/DropSelection";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

export class TaxCenter extends Component {

  constructor(props) {
    super(props);
    this.taxYear = getTaxYear();
    this.state = {
      dataLoaded: false,
      data: [],
      agencies: [],
      totalResults: 0,
      formData: {},
      showIndicator: false,
      page: 1,
      limit: 30,
      taxYear: this.taxYear,
      agency: -1,
      status: 2,
      loading: false,
      editStatus: null,
      editStatusValue: null,
      editAgency: null,
      editAgencyValue: null,
      calendarMenu: []
    }
    this.yearsOptions = [];
    for (let i = 2017; i <= this.taxYear; i++) {
      this.yearsOptions.push(i);
    }
    this.yearsOptions.reverse();
    this.backFive = new Date();
    addHours(this.backFive, -24 * 5);
  }

  componentDidMount() {
    this.getData();
  }

  editorUpdates(lmsId, intakeId) {
    this.getData();
  }

  getData() {
    const self = this;
    this.setState({loading: true}, () => {
      getData(`intakes/list/${this.state.taxYear}/${this.state.agency}/${this.state.status}`, {}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            self.setState({
              data: data.data.intakes,
              dataLoaded: true,
              showIndicator: false,
              agencies: data.data.agencies,
              loading: false,
              calendarMenu: data.data.calendarMenu || []
            });
          }
        })
        .catch(error => {
          console.error(error);
          self.setState({
            loading: false
          });
        });
    });
  }

  onSelect(leadId) {
    EventClient.emit("LMS_ENTRY_EDIT", leadId);
  }

  onSelectIntake(leadId, intakeId) {
    EventClient.emit("TAX_INTAKE_ENTRY_EDIT", {id: intakeId, lms_id: leadId});
  }

  bookOldPortal(lmsId) {
    window.open(`/sso/A45nbkF9DlskZjkdjgJkfmdmTnmtnjDFk98ojiFo4t9u8joiOJIGIJOGreoi345otjis98s34rtoKLFGkleostjWhisgGRIURtgisaeo/${encodeURIComponent(`cal/sched.php?id=${lmsId}`)}`)
  }

  buttonFormatter(cell, row, context, calendarMenu) {
    // console.log(cell)
    return <div style={{display: "flex"}}>
      <Button onClick={(evt) => {
        context.onSelectIntake(row.lms_id, row.id)
      }}>Intake</Button>&nbsp;
      <Button onClick={(evt) => {
        context.onSelect(row.lms_id)
      }}>LMS</Button> &nbsp;
      {row && row.status && (row.status === 2 || row.status === 3) && (
        <DropSelection displayText={"Schedule"}
                       items={{
                         calendar: {
                           header: "Select Calendar...",
                           options: calendarMenu,
                           selected: []
                         }
                       }}
                       onClick={(category, value) => {
                         window.open(`/calendar/${value || getGlobalState('loginID')}/schedule/${row.lms_id}`)
                       }}
        />
      )}

    </div>
  }

  updateStatus(lmsId, intakeId, status) {
    const self = this;
    self.setState({loading: true}, () => {

      patchData(`intakes/${lmsId || 0}/${intakeId || 0}/status/${status}`, {}, this.props.token)
        .then((data) => {
          // console.log(data);
          if (data.status === "Success") {
            self.setState({editStatus: null, editStatusValue: null}, () => {
              self.getData();
            });
            EventClient.emit("TOAST_SUCCESS", "Status Saved Successfully");
          } else {
            self.setState({loading: false, editStatus: null, editStatusValue: null});
            EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
          }
        })
        .catch(error => {
          self.setState({loading: false, editStatus: null, editStatusValue: null});
          EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
          console.error(error);
        });
    });
  }

  updateAgency(lmsId, intakeId, agency) {
    const self = this;
    self.setState({loading: true}, () => {

      patchData(`intakes/${lmsId || 0}/${intakeId || 0}/agency/${agency}`, {}, this.props.token)
        .then((data) => {
          // console.log(data);
          if (data.status === "Success") {
            self.setState({editAgency: null, editAgencyValue: null}, () => {
              self.getData();
            });
            EventClient.emit("TOAST_SUCCESS", "Agency Saved Successfully");
          } else {
            self.setState({loading: false, editAgency: null, editAgencyValue: null});
            EventClient.emit("TOAST_ERROR", "Agency not saved. Try later");
          }
        })
        .catch(error => {
          self.setState({loading: false, editAgency: null, editAgencyValue: null});
          EventClient.emit("TOAST_ERROR", "Agency not saved. Try later");
          console.error(error);
        });
    });
  }

  displayAgency(agencyId, row) {
    let agencyText = "";
    if (this.state.agencies && this.state.agencies.length > 0) {
      let agency = this.state.agencies.find((agenc) => agenc.id === agencyId);
      agencyText = agency && agency.display || "Unknown"
    } else {
      agencyText = "Unknown";
    }
    if (row.id !== this.state.editAgency) {
      return <span>
        {agencyText}&nbsp;
        <i className="icon-pencil"
           onClick={() => this.setState({editAgencyValue: agencyId, editAgency: row.id})}
           title={"Change Agency"}
           style={{cursor: "pointer"}}/>
      </span>
    } else {
      return <div style={{display: "flex", alignItems: "center"}}>
        <Input
          type="select"
          id="agency"
          value={getFormFieldValue(this.state.editAgencyValue)}
          onChange={(evt) => {
            const value = evt.target.value;
            this.setState({editAgencyValue: value}, () => {
              this.updateAgency(row.lms_id, row.id, value)
            })
          }}
        >
          {this.state.agencies.map((agency, index) => {
            return <option key={index} value={agency.id}>{agency.display}</option>
          })}
        </Input>&nbsp;
        <i className="cil-action-undo"
           onClick={() => this.setState({editAgencyValue: null, editAgency: null})}
           title={"Cancel/Undo"}
           style={{cursor: "pointer"}}/>
      </div>
    }
  }

  displayStatus(cell, row) {
    if (row.id !== this.state.editStatus) {
      return <span>
        {TaxIntakeStatusList[cell]}&nbsp;
        <i className="icon-pencil"
           onClick={() => this.setState({editStatusValue: cell, editStatus: row.id})}
           title={"Change Status"}
           style={{cursor: "pointer"}}/>
      </span>
    } else {
      return <div style={{display: "flex", alignItems: "center"}}>
        <Input
          type="select"
          id="status"
          value={getFormFieldValue(this.state.editStatusValue)}
          onChange={(evt) => {
            const value = evt.target.value;
            this.setState({editStatusValue: value}, () => {
              this.updateStatus(row.lms_id, row.id, value)
            })
          }}
        >
          {TaxIntakeStatusList.map((display, value) => {
            return <option key={value} value={value}>{display}</option>
          })}
        </Input>&nbsp;
        <i className="cil-action-undo"
           onClick={() => this.setState({editStatusValue: null, editStatus: null})}
           title={"Cancel/Undo"}
           style={{cursor: "pointer"}}/>
      </div>
    }
  }

  rowStyleFormat(row, rowIdx, self) {
    const response = {overFlow:"visible"}
    if (!row || !row.updated) return {...response}
    let dated = new Date(row.updated);

    if (row.status < 4 && dated < self.backFive) return {backgroundColor: brandDanger,...response};
    return {...response};
  }

  render() {
    let calendarMenu = (this.state.calendarMenu || []).filter((cal) => cal.fwrite === 1).map((cal) => ({
      display: `${cal.fname} ${cal.lname}`.trim(),
      value: cal.uid
    })).sort((a, b) => a.display.localeCompare(b.display));

    return (
      <Card>
        {this.state.dataLoaded && (
          <Fragment>
            <CardHeader>
              <i className="icon-menu"/>Tax Center

              <div className="card-actions" style={{display: "flex"}}>
                <div style={{display: "inline-flex", paddingRight: 25, paddingTop: 6}}>
                  <span style={{fontSize: 12, paddingTop: 12}}>Agency</span>
                  <Input type={"select"}
                         value={this.state.agency}
                         onChange={(evt) => {
                           this.setState({agency: evt.target.value}, () => this.getData());
                         }}
                  >
                    <option key={-1} value={-1}>All</option>
                    {this.state.agencies.map((agency, index) => {
                      return <option key={index} value={agency.id}>{agency.display}</option>
                    })}
                  </Input>
                </div>

                <div style={{display: "inline-flex", paddingRight: 25, paddingTop: 6}}>
                  <span style={{fontSize: 12, paddingTop: 12}}>Year</span>
                  <Input type={"select"}
                         value={this.state.taxYear}
                         onChange={(evt) => {
                           this.setState({taxYear: evt.target.value}, () => this.getData());
                         }}
                  >
                    {this.yearsOptions.map((year, index) => {
                      return <option key={index} value={year}>{year}</option>
                    })}
                  </Input>
                </div>

                <div style={{display: "inline-flex", paddingRight: 25, paddingTop: 6}}>
                  <span style={{fontSize: 12, paddingTop: 12}}>Status</span>
                  <Input type={"select"}
                         value={this.state.status}
                         onChange={(evt) => {
                           this.setState({status: evt.target.value}, () => this.getData());
                         }}
                  >
                    <option key={-1} value={-1}>Any</option>
                    {TaxIntakeStatusList.map((display, value) => {
                      return <option key={value} value={value}>{display}</option>
                    })}
                  </Input>
                </div>

                <button onClick={() => this.getData()}>
                  <small className="text-muted">Refresh</small>
                </button>

              </div>

            </CardHeader>
            <CardBody>
              <BootstrapTable data={this.state.data}
                              expandColumnOptions={{expandColumnVisible: true}}
                              version="4" striped hover pagination search
                              trStyle={(row, ind) => this.rowStyleFormat(row, ind, this)}
                              tdStyle={{overflow: "visible"}}
                              options={this.options}>
                <TableHeaderColumn isKey={true} dataField="id" hidden>Id</TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataSort>Name</TableHeaderColumn>
                <TableHeaderColumn dataField="cphone" dataSort hidden>Phone</TableHeaderColumn>
                <TableHeaderColumn dataField="email" dataSort hidden>Email</TableHeaderColumn>
                <TableHeaderColumn dataField="ssn" dataSort hidden>SSN</TableHeaderColumn>
                <TableHeaderColumn dataField="agencyid" dataSort
                                   dataFormat={(cell, row) => this.displayAgency(cell, row)}>Agency</TableHeaderColumn>
                <TableHeaderColumn dataField="status" dataSort
                                   dataFormat={(cell, row) => this.displayStatus(cell, row)}>Status</TableHeaderColumn>
                <TableHeaderColumn dataField="created" dataSort dataFormat={(cell, row) => {
                  let dateStr = new Date(cell);
                  return `${dateStr.toDateString()}`;
                }}>Received</TableHeaderColumn>
                <TableHeaderColumn
                  tdStyle={{overflow: "visible"}}
                  dataFormat={(cell, row) => this.buttonFormatter(cell, row, this, calendarMenu)}>Actions</TableHeaderColumn>
              </BootstrapTable>
            </CardBody>
            {this.state.loading && (
              <div style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                paddingTop: 100,
                backgroundColor: "#fff",
                opacity: 0.5,
                top: 0,
                left: 0
              }}>
                <div className="sk-double-bounce" style={{opacity: 1}}>
                  <div className="sk-child sk-double-bounce1"></div>
                  <div className="sk-child sk-double-bounce2"></div>
                </div>
              </div>
            )}
          </Fragment>
        )}
        <TaxIntakeEditor onUpdate={(lmsId, intakeId) => this.editorUpdates(lmsId, intakeId)}/>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Leads/TaxCenter.js